import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import './css/ConsentModal.css';

const ConsentModal = ({ show, handleAccept, handleDecline }) => {
  const [showMore, setShowMore] = useState(false);

  if (!show) return null;

  const longCopy = (
    <>
      We use cookies and Google Analytics to help us understand how our site is used. By clicking &quot;Accept&quot;,
      you consent to analytics; you can read more in our Privacy Policy.
    </>
  );

  return (
    <div
      className={`consent-banner${showMore ? ' consent-banner--expanded' : ''}`}
      role="dialog"
      aria-label="Cookie notice"
    >
      <div className="consent-content">
        <div className="consent-text">
          {/* Mobile: 2 words + tiny actions on one line; details only after More */}
          <div className="consent-mobile d-md-none">
            <div className="consent-mobile__row">
              <span className="consent-two-words" title="We use cookies — tap More for details">
                Cookie notice
              </span>
              <div className="consent-actions consent-actions--tight">
                <Button
                  className="consent-btn-sm"
                  size="sm"
                  variant="primary"
                  onClick={handleAccept}
                >
                  OK
                </Button>
                {!showMore ? (
                  <Button
                    className="consent-btn-sm consent-btn-ghost"
                    size="sm"
                    variant="link"
                    onClick={() => setShowMore(true)}
                  >
                    More
                  </Button>
                ) : (
                  <Button
                    className="consent-btn-sm consent-btn-ghost"
                    size="sm"
                    variant="link"
                    onClick={handleDecline}
                  >
                    Decline
                  </Button>
                )}
              </div>
            </div>
            {showMore ? <p className="consent-fineprint">{longCopy}</p> : null}
          </div>

          {/* Desktop: compact, small type */}
          <div className="d-none d-md-flex consent-desktop">
            <div className="consent-text-block">
              <h5 className="consent-title consent-title--desktop">Privacy &amp; cookies</h5>
              <p className="consent-desc">
                {showMore ? (
                  <>
                    We use cookies and Google Analytics to ensure you have the best experience on our site. These tools
                    help us understand how our site is being used, enabling us to enhance your experience. Without your
                    consent, some features may not function properly, and your experience may be less personalized.
                    <br />
                    <br />
                    By clicking &quot;Accept&quot;, you allow us to track your interactions to improve site functionality
                    and enhance your experience. If you choose &quot;Decline&quot;, certain features and functionalities
                    may not be available to you.
                  </>
                ) : (
                  <>
                    We use cookies and similar technologies to improve your experience. By clicking &quot;Accept&quot;,
                    you consent to the use of these technologies for analytics and marketing purposes.
                  </>
                )}
              </p>
            </div>
            <div className="consent-actions consent-actions--desktop">
              <Button className="consent-btn-sm" size="sm" variant="primary" onClick={handleAccept}>
                Accept
              </Button>
              {showMore ? (
                <Button
                  className="consent-btn-sm consent-btn-ghost"
                  size="sm"
                  variant="link"
                  onClick={handleDecline}
                >
                  Decline
                </Button>
              ) : (
                <Button
                  className="consent-btn-sm consent-btn-ghost"
                  size="sm"
                  variant="link"
                  onClick={() => setShowMore(true)}
                >
                  See more
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsentModal;
